<div fxLayout="column" fxLayoutGap="30px" class="margin hide-overflow">
  @if (isLoadingPlanoAcao) {
    <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
  @if (planosGeralList.length === 0 && !isLoadingPlanoAcao) {
    <div fxLayout="row" fxLayoutAlign="center center">
      Não há plano de ação cadastrado
    </div>
  }

  @if (planosGeralList && planosGeralList.length > 0) {
    <span class="title">Plano de Ação</span>
  }
  <div class="box">
    @if (planosGeralList && planosGeralList.length > 0) {
      <mat-accordion>
        @for (plan of planosGeralList; track plan; let i = $index) {
          <mat-expansion-panel class="mat-elevation-z0 plano-list" [ngClass]="{'grey-bg': planosGeralList}"
            >
            <mat-expansion-panel-header class="panel-height" style="padding-left: 40px; padding-right: 40px;">
              <mat-panel-title fxLayout="row" fxLayoutGap="15px">
                <span class="body-title" fxFlex="95">{{plan.nomeAcao}}</span>
                <div fxFlex="5">
                  <div class="data-plano-header">Ações</div>
                  <span class="soma">{{plan.planoSolucaoDTOs.length}}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (plan.planoSolucaoDTOs?.length > 0) {
              <div fxLayout="column" class="plano-detail" fxFlex="60">
                <div fxLayout="column" fxLayoutAlign="center">
                  <div class="plano-detail-header">
                    <div class="plano-detail-header-margin">
                      <div fxFlex="100" style="color: white;" class="item-plano-acao-projeto">Ações</div>
                    </div>
                  </div>
                  <div class="plano-detail-body">
                    <div class="plano-detail-body-margin" fxLayout="column">
                      @for (acao of plan.planoSolucaoDTOs; track acao) {
                        <div class="item-plano-acao-projeto">
                          <span>{{acao.solucaoDTO.descricao}}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (!plan.planoSolucaoDTOs || plan.planoSolucaoDTOs?.length == 0) {
              <div>
                Não há ações cadastradas para este plano de ação
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>

  @if (isLoadingPlanoSetorial) {
    <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
  @if (planoSetorialList.length === 0 && !isLoadingPlanoSetorial) {
    <div fxLayout="row" fxLayoutAlign="center center">
      Não há plano de ação setorial cadastrado
    </div>
  }

  @if (planoSetorialList && planoSetorialList.length > 0) {
    <span class="title">Plano de Ação Setorial</span>
  }
  <div class="box">
    @if (planoSetorialList && planoSetorialList.length > 0) {
      <mat-accordion>
        @for (plan of planoSetorialList; track plan; let i = $index) {
          <mat-expansion-panel class="mat-elevation-z0 plano-list" [ngClass]="{'grey-bg': planoSetorialList}"
            >
            <mat-expansion-panel-header class="panel-height" style="padding-left: 40px; padding-right: 40px;">
              <mat-panel-title fxLayou t="row" fxLayoutGap="15px">
                <span class="body-title" fxFlex="95">{{plan.nomeAcao}}</span>
                <div fxFlex="5">
                  <div class="data-plano-header">Ações</div>
                  <span class="soma">{{plan.planoSolucaoDTOs.length}}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (plan.planoSolucaoDTOs?.length > 0) {
              <div fxLayout="column" class="plano-detail" fxFlex="60">
                <div fxLayout="column" fxLayoutAlign="center">
                  <div class="plano-detail-header">
                    <div class="plano-detail-header-margin">
                      <div fxFlex="100" style="color: white;" class="item-plano-acao-projeto">Ações</div>
                    </div>
                  </div>
                  <div class="plano-detail-body">
                    <div class="plano-detail-body-margin" fxLayout="column">
                      @for (acao of plan.planoSolucaoDTOs; track acao) {
                        <div class="item-plano-acao-projeto">
                          <span>{{acao.solucaoDTO.descricao}}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (!plan.planoSolucaoDTOs || plan.planoSolucaoDTOs?.length == 0) {
              <div>
                Não há ações cadastradas para este plano setorial
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>

</div>
